<template>
  <div class="container o-form-page">
    <h3 class="display-4" @click="enableDebug($event)">Inbox</h3>
    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :search-fields-list="custom_search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      :schema="schema"
      :query-select-options="options"
      @reset_table="reset_table"
    >
      <template slot="middle">
        <BButton class="my-2 mx-2" variant="primary" @click="mark_all_read">
          Mark all as read
        </BButton>
      </template>
    </o-list-toolbar>

    <BTable
      hover
      :fields="fields"
      :items="notification_items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
      @row-selected="onRowSelected"
      @sort-changed="change_sort"
      bordered
      class="o-list"
      head-variant="light"
      no-local-sorting
      striped
      thead-class="o-gradient-header"
      @row-hovered="showMoreMenu"
      @row-unhovered="hideMoreMenu"
    >
      <template #cell(notification)="{ index, item }">
        <span class="d-flex flex-row justify-content-between">
          <span class="d-flex flex-column">
            <span class="text-secondary mb-1">{{
              createdDate(item.notification)
            }}</span>
            <h6 :class="readStatusFont(item.notification)">
              {{ item.notification.notification_set[0].description }}
            </h6>
          </span>
          <BNavItemDropdown
            v-if="hovered_item === item"
            right
            no-caret
            class="align-self-start list-unstyled pa-0 more-menu"
          >
            <template v-slot:button-content>
              <dots-horizontal-icon
                class="icon-2x text-secondary"
              ></dots-horizontal-icon>
            </template>
            <BDropdownItem
              v-if="can_be_marked_as_read(item)"
              @click="markRead(item)"
              >Mark as read</BDropdownItem
            >
            <BDropdownItem
              v-if="can_be_marked_as_unread(item)"
              @click="markUnread(item)"
              >Mark as unread</BDropdownItem
            >
            <BDropdownHeader
              v-if="
                !can_be_marked_as_unread(item) && !can_be_marked_as_read(item)
              "
            >
              No more options
            </BDropdownHeader>
          </BNavItemDropdown>
        </span>
      </template>

      <template #cell(actions)="{ index, item }">
        <BButton
          v-if="btn"
          :href="btn.url ? btn.url : '#'"
          v-for="btn in item.actions"
          :key="btn.id"
          block
          :variant="btn.style"
          @click="click_button(item.notification, btn)"
          style="min-width: 150px"
        >
          {{ btn.button_text }}
        </BButton>
        <h4 class="text-center text-secondary" v-if="item.actions.length === 0">
          No button
        </h4>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'notification.create' }">
          create a new item
        </router-link>
      </template>
    </BTable>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  BButton,
  BDropdownHeader,
  BDropdownItem,
  BNavItemDropdown,
  BTable,
} from "bootstrap-vue";
import _ from "lodash";
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils.js";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify.js";
import schema from "../../schema/index.js";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar.vue";
import OListPaging from "../../../vue-ocom/components/list/OListPaging.vue";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay.vue";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay.vue";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay.vue";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay.vue";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay.vue";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad.vue";
import EmailIcon from "vue-material-design-icons/Email.vue";
import LinkIcon from "vue-material-design-icons/Link.vue";
import DotsHorizontalIcon from "vue-material-design-icons/DotsHorizontal.vue";
import moment from "moment";
import { mapActions } from "vuex";

export default {
  components: {
    BButton,
    BTable,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownHeader,
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    DotsHorizontalIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    /*
    CreateListPageMixin('Notification', 'notification'), */
    CreateListPageMixin("UserNotification", "user_notification"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("UserNotification"),
    CreateCodeTableFetchMixin(["User"]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.UserNotification,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.UserNotification),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        // { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        // {
        //   name: "Non Active",
        //   code: "inactive",
        //   options: { offset: 0, sort: "id" },
        // },
        { name: "Unread", code: "unread", options: { offset: 0, sort: "id" } },
        { name: "Read", code: "read", options: { offset: 0, sort: "id" } },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
      hovered_item: null,
    };
  },
  computed: {
    options() {
      return {};
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "notification",
        "buttons",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
    getReadStatus() {
      return (status) => {
        if (status && status.read) {
          return moment(status.read).format("MMM Do YY, h:mm:ss a");
        }

        return "Unread";
      };
    },
    readStatusFont() {
      return (status) =>
        status.read ? "font-weight-normal" : "font-weight-bold";
    },
    notification_items() {
      //Simplify the object
      const mapped_notifications = _.map(this.items, function (item) {
        var notification = item.notification_set[0];

        var result = { notification: item, actions: notification.buttons };
        delete result.notification_set;

        return result;
      });

      return _.orderBy(mapped_notifications, "created_date", "desc"); // newest first
    },
    can_be_marked_all_as_read() {
      return _.filter(this.items, (item) => {
        return item.notification_set[0].buttons.length <= 1;
      });
    },
    can_be_marked_as_read() {
      return (item) =>
        item.notification.notification_set[0].buttons.length <= 1 &&
        !item.notification.read
          ? true
          : false;
    },
    can_be_marked_as_unread() {
      return (item) => (item.notification.read ? true : false);
    },
    createdDate() {
      return (notification) => {
        const today = moment();
        const difference = today.diff(notification.created_date, "weeks");

        if (notification.created_date) {
          return moment(notification.created_date).fromNow();
        }

        return;
      };
    },
    custom_search_field_list() {
      return [
        { text: "All", value: "" },
        { text: "Description", value: "notification__description" },
      ];
    },
  },
  methods: {
    ...mapActions("UserNotificationModule", ["patchItem"]),
    click_button(notification, button_clicked) {
      this.patchItem({
        id: notification.id,
        button_selected: button_clicked.id,
        read: new Date(),
      });

      if (button_clicked.url) {
        window.location.url = button_clicked.url;
      }
    },
    mark_all_read() {
      const vm = this;

      _.each(this.can_be_marked_all_as_read, (item) => {
        const button_id =
          item.notification_set[0].buttons.length > 0
            ? item.notification_set[0].buttons[0].id
            : null;

        if (!item.read) {
          vm.patchItem({
            id: item.id,
            button_selected: button_id,
            read: new Date(),
          });
        }
      });
    },
    showMoreMenu(item) {
      this.hovered_item = item;
    },
    hideMoreMenu() {
      this.hovered_item = null;
    },
    markRead(item) {
      const button_id =
        item.notification.notification_set[0].buttons.length === 1
          ? item.notification.notification_set[0].buttons[0].id
          : null;
      console.log(item);
      if (!item.notification.read) {
        this.patchItem({
          id: item.notification.id,
          button_selected: button_id,
          read: new Date(),
        });
      }
    },
    markUnread(item) {
      this.patchItem({
        id: item.notification.id,
        button_selected: null,
        read: null,
      });
    },
  },
};
</script>

<style lang="scss">
.material-design-icon.icon-2x {
  height: 2em;
  width: 2em;
}

.material-design-icon.icon-2x > .material-design-icon__svg {
  height: 2em;
  width: 2em;
}

.b-nav-dropdown.more-menu > .nav-link {
  padding: 0;
}
</style>
